export enum Role {
    SUPER_ADMIN = 'SUPER_ADMIN',
    BACK_OFFICE = 'BACK_OFFICE',
    DEVELOPER = 'DEVELOPER'
}